import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safehtml'
})
export class SafehtmlPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) {}

  transform(suggestedName: string, source: string, page: string): SafeHtml {
    const tableHtml = `
      <table>
        <thead>
          <tr>
            <th>Suggest Name</th>
            <th>Source</th>
            <th>Page</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${suggestedName}</td>
            <td>${source}</td>
            <td>${page}</td>
          </tr>
        </tbody>
      </table>
    `;
    return this.domSanitizer.bypassSecurityTrustHtml(tableHtml);
  }

}
